/**
 * Voice webhook duration filter — stored as a synthetic field on inbound/outbound filters.
 * Backend should trigger only when call_duration > threshold (seconds).
 */
export const WEBHOOK_TIME_FILTER_FIELD = "min_call_duration_sec";

export const WEBHOOK_TIME_THRESHOLD_ERROR =
  "Please enter the number of seconds.";

/**
 * @param {unknown} raw — user input or first element of selectedValue[]
 * @returns {string|null} error message or null if valid
 */
export function validateWebhookTimeThresholdSeconds(raw) {
  if (raw === null || raw === undefined) {
    return WEBHOOK_TIME_THRESHOLD_ERROR;
  }
  const s = String(raw).trim();
  if (s === "") {
    return WEBHOOK_TIME_THRESHOLD_ERROR;
  }
  if (!/^\d+$/.test(s)) {
    return WEBHOOK_TIME_THRESHOLD_ERROR;
  }
  const n = parseInt(s, 10);
  if (n < 1) {
    return WEBHOOK_TIME_THRESHOLD_ERROR;
  }
  return null;
}
